(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-application-form"] && !Shopify.designMode) return;
  try {
    
    const countries = [
        "United States", "United Kingdom", "Canada", "Australia", "Germany", "France", "Japan", "Brazil", "India", "China", 
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", 
        "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", 
        "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Central African Republic", "Chad", "Chile", 
        "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", 
        "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", 
        "Finland", "Gabon", "Gambia", "Georgia", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", 
        "Honduras", "Hungary", "Iceland", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Jordan", "Kazakhstan", 
        "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", 
        "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", 
        "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", 
        "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State", 
        "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", 
        "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", 
        "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", 
        "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", 
        "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", 
        "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", 
        "Y Yemen", "Zambia", "Zimbabwe"
    ];

    const locationSelect = document.getElementById('location');
    if (locationSelect) {
        countries.forEach(country => {
            const option = document.createElement('option');
            option.value = country;
            option.textContent = country;
            locationSelect.appendChild(option);
        });
    }

    const primaryChannelSelect = document.getElementById('primary-channel');
    const otherChannelInput = document.getElementById('other-channel-input');

    if (primaryChannelSelect) {
        primaryChannelSelect.addEventListener('change', function() {
            if (this.value === 'Other') {
                otherChannelInput.classList.remove('hidden');
                otherChannelInput.required = true;
            } else {
                otherChannelInput.classList.add('hidden');
                otherChannelInput.required = false;
                otherChannelInput.value = '';
            }
        });
    }
    
    const form = document.getElementById('creatorForm');
    const statusDiv = document.getElementById('form-status');
    const submitButton = document.getElementById('submit-button');

    async function handleSubmit(event) {
        event.preventDefault();
        const data = new FormData(event.target);
        
        statusDiv.textContent = 'Submitting...';
        statusDiv.style.backgroundColor = '#4b5563'; /* bg-gray-700 */
        statusDiv.style.color = '#d1d5db'; /* text-gray-200 */
        statusDiv.classList.remove('hidden');
        submitButton.disabled = true;

        fetch(event.target.action, {
            method: form.method,
            body: data,
            headers: { 'Accept': 'application/json' }
        }).then(response => {
            if (response.ok) {
                window.location.href = '/pages/creator-application-submission?view=creator-submission';
            } else {
                response.json().then(data => {
                    const errorMsg = data.errors ? data.errors.map(e => e.message).join(", ") : 'Oops! There was a problem submitting your form';
                    showError(errorMsg);
                })
            }
        }).catch(error => {
            showError('Oops! There was a problem submitting your form');
        }).finally(() => {
            submitButton.disabled = false;
        });
    }
    
    function showError(message) {
        statusDiv.textContent = message;
        statusDiv.style.backgroundColor = 'rgba(239, 68, 68, 0.1)';
        statusDiv.style.color = '#fca5a5';
        statusDiv.style.borderColor = '#991b1b';
    }

    if (form) {
        form.addEventListener("submit", handleSubmit)
    }

  } catch(e) { console.error(e); }
})();
})();
